import { useState, useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { companyService } from '@/services/company-service'

export function PricingDefaultsPage() {
  const [defaultFuelChargePercent, setDefaultFuelChargePercent] = useState(18)
  const [isSaving, setIsSaving] = useState(false)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    companyService.getSettings().then((settings) => {
      if (settings.defaultFuelChargePercent !== undefined && settings.defaultFuelChargePercent !== null)
        setDefaultFuelChargePercent(settings.defaultFuelChargePercent)
    }).catch(() => {
      // keep defaults
    }).finally(() => setLoaded(true))
  }, [])

  const handleSave = async () => {
    setIsSaving(true)
    try {
      await companyService.updateSettings({
        defaultFuelChargePercent,
      })
    } catch {
      // TODO: show error toast
    } finally {
      setIsSaving(false)
    }
  }

  if (!loaded) return null

  return (
    <div>
      {/* Page Header — matches pricing pages */}
      <div className="est-list-head">
        <h1 className="est-list-title">Fuel Charge</h1>
      </div>

      <p className="lch-page-desc">
        These default rates are automatically applied to all new estimates. Estimators cannot override these values.
      </p>

      {/* Content card */}
      <div className="card est-list-card">
        <div className="cd-page-inner">
          <div className="cd-field-group">
            <div>
              <Label htmlFor="defaultFuelCharge" className="cd-field-label">Fuel Charge</Label>
              <p className="cd-field-help">
                This fuel charge percentage is applied to all equipment line items.
              </p>
            </div>
            <div className="cd-field-input">
              <Input
                id="defaultFuelCharge"
                type="number"
                min="0"
                max="100"
                step="0.5"
                value={defaultFuelChargePercent || ''}
                onChange={(e) => setDefaultFuelChargePercent(parseFloat(e.target.value) || 0)}
              />
              <span className="cd-field-suffix">%</span>
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
    </div>
  )
}
